<template lang="pug">
el-container.main
    .main-header
        .welcome
            span.title 欢迎使用, {{ user.displayName || user.name }}
        .welcome
            span.slogn 管理自己的信息和安全，从而让我们更好地为您服务
    .main-content
        .block
            .block-desc
                .desc-title 个人信息 
                .desc-slogn 查看您的账号基本信息、密码等安全设置
            .block-img
                img(src="/img/profile.png")
            el-divider.block-divider
            .block-nav 
                router-link(to="/profile") 更新个人信息
        .block
            .block-desc
                .desc-title 组织团队
                .desc-slogn 管理自己的组织或团队，便于协作、分享
            .block-img
                img(src="/img/org-arch.jpg")
            el-divider.block-divider
            .block-nav 
                router-link(to="/settings/org") 管理组织
                router-link(to="/settings/team") 管理团队
                router-link(to="/settings/member") 管理成员
</template>

<script>
// @ is an alias to /src
import { getUserAPI } from "@/services";

export default {
    name: "dashboard",
    data() {
        return {
            loading: false,
            user: {}
        };
    },
    methods: {
        async fetch() {
            this.loading = true;
            try {
                const res = await getUserAPI(localStorage.getItem("account"));
                if (res.status === 200) {
                    this.user = Object.assign({}, res.data);
                    // this.accountType = res.data.accountType;
                    // this.displayName = res.data.displayName
                    //     ? res.data.displayName
                    //     : this.account;
                }
            } catch {
                console.log("get user info failed");
                this.$message.error("获取信息失败，请尝试刷新或重新登录");
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>

<style lang="stylus" scoped>
.main-header {
    flex-wrap: wrap;
}

.welcome {
    display: flex;
    height: 56px;
    align-items: center;
    flex-basis: 100%;
    background: #ffffff;
}

.title {
    margin: auto;
    font-size: 30px;
}

.slogn {
    margin: auto;
    color: #cccccc;
}

.main-content {
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;
    max-width: 1000px;
    margin: auto;
}

.block {
    display: flex;
    flex-wrap: wrap;
    width: 408px;
    height: 202px;
    margin: 40px 10px;
    padding: 20px;
    border: solid 1px #bbbbbb;
    border-radius: 15px;
}

.block-desc {
    display: flex;
    flex-wrap: wrap;
    flex-basis: 60%;

    .desc-title {
        display: flex;
        font-size: 20px;
    }

    .desc-slogn {
        display: flex;
        color: #cccccc;
    }
}

.block-img {
    // display: flex;
    // flex-basis: 40%;
    margin: auto;

    img {
        width: 108px;
        height: 108px;
    }
}

.block-divider {
    margin: 0px;

    img {
        width: 120px;
        height: 120px;
    }
}

.block-nav {
    display: flex;
    margin-top: -20px;

    a {
        color: #39ABC0;
        text-decoration-line: none;
        margin-left: 10px;
    }
}
</style>
